export const API_URL: string = 'http://api.sciencefairfarnorth.ac.nz';



// WEBPACK FOOTER //
// ./src/config/app.config.ts